import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Loading from "../../components/Loading";
import { getProducts } from "../../services";

export default function Product({ categoryId: propCategoryId }) {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    // پشتیبانی همزمان از پراپ پاس داده شده یا پارامتر URL
    const activeCategoryId = propCategoryId || searchParams.get("categoryId");

    const loadData = async () => {
        if (!activeCategoryId) {
            setProducts([]);
            return;
        }

        setLoading(true);
        try {
            // ۱. دریافت محصولات
            const productsData = await getProducts(activeCategoryId);

            // ۲. فیلتر محصولات در سمت فرانت (در صورتی که سرور همه را بازگرداند)
            let filteredProducts = Array.isArray(productsData) ? productsData : [];
            filteredProducts = filteredProducts.filter(
                (p) =>
                    p.categoryId?.toString() === activeCategoryId.toString() ||
                    p.parentCategoryId?.toString() === activeCategoryId.toString()
            );

            setProducts(filteredProducts);
        } catch (ex) {
            console.error("خطا در دریافت لیست محصولات:", ex);
            setProducts([]);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        loadData();
    }, [activeCategoryId]);

    return (
        <div className="w-100" dir="rtl">
            {/* وضعیت لودینگ محصولات */}
            {loading && (
                <div className="row my-4">
                    <div className="col-12 text-center">
                        <Loading />
                    </div>
                </div>
            )}

            {/* لیست محصولات */}
            {!loading && products.length > 0 && (
                <div className="row gx-3 gy-1">
                    {products.map((product) => {
                        const finalPrice = product.discount > 0
                            ? product.price - (product.price * product.discount) / 100
                            : product.price;

                        return (
                            <div className="col-12 col-md-6" key={product.id}>
                                <div
                                    className="charge-box text-start p-3 border rounded-3 shadow-sm"
                                >
                                    <div className="row align-items-center g-3">
                                        {/* تصویر محصول */}
                                        <div className="col-4 col-sm-3 text-center">
                                            {product.thumbnail ? (
                                                <div
                                                    className="bg-white rounded-3 p-2 d-flex align-items-center justify-content-center mx-auto"
                                                    style={{ width: "80px", height: "80px" }}
                                                >
                                                    <img
                                                        className="img-fluid"
                                                        src={product.thumbnail}
                                                        alt={product.name || product.title}
                                                        style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain" }}
                                                    />
                                                </div>
                                            ) : (
                                                <div
                                                    className="bg-dark bg-opacity-50 border border-secondary text-white rounded-3 d-flex align-items-center justify-content-center mx-auto"
                                                    style={{ width: "80px", height: "80px" }}
                                                >
                                                    <span className="small text-secondary">بدون تصویر</span>
                                                </div>
                                            )}
                                        </div>
                                        {/* اطلاعات و قیمت محصول */}
                                        <div className="col-8 col-sm-9 d-flex flex-column justify-content-between text-start">
                                            <div>
                                                <strong className="d-block mt-2 mb-2 text-warning fs-6">
                                                    {product.name || product.title}
                                                </strong>

                                                <div>
                                                    {product.isInComingSoon ? (
                                                        <span className="text-success fw-bold fs-6">به زودی تومان</span>
                                                    ) : product.discount > 0 ? (
                                                        <div className="d-flex align-items-center gap-2 flex-wrap">
                                                            <span className="text-success fw-bold fs-6">
                                                                {finalPrice.toLocaleString("fa-IR")} تومان
                                                            </span>
                                                            <span className="text-white text-opacity-50 text-decoration-line-through small">
                                                                {product.price.toLocaleString("fa-IR")} تومان
                                                            </span>
                                                        </div>
                                                    ) : (
                                                        <span className="text-success fw-bold fs-6">
                                                            {product.price ? `${product.price.toLocaleString("fa-IR")} تومان` : "0"}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>

                                            {/* دکمه انتقال یافته به سمت چپ با کرسر پوینتر */}
                                            <div className="mt-3 mb-2 w-100 d-flex justify-content-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-warning fw-bold px-4 py-1 rounded-3"
                                                    style={{ width: "180px",height:"35px", cursor: "pointer" }}
                                                    onClick={() => navigate(`/store/product-detail/${product.id}`)}
                                                >
                                                    مشاهده محصول
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}

            {/* در صورت خالی بودن لیست محصولات این گروه */}
            {!loading && products.length === 0 && (
                <div className="row my-4">
                    <div className="col-12">
                        <div className="alert alert-secondary text-center">
                            هیچ محصولی برای این گروه یافت نشد.
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
}
